import { render, staticRenderFns } from "./insights-article-page.vue?vue&type=template&id=08c4bbe2&"
var script = {}
import style0 from "./insights-article-page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports